
<v-dialog
    v-model="touched"
    max-width="480"
    persistent
>
    <template #activator="{ on, attrs }">
        <slot v-bind="{ on, attrs }"></slot>
    </template>

    <v-card>
        <v-card-title class="customized-primary white--text">
            {{ t('import_workouts_title') }}
        </v-card-title>

        <v-card-text class="pb-0">
            <v-form class="mt-6">
                <div class="form-group-horizontal">
                    <div class="horizontal-label">{{ t('import_workouts_browse_files') }}</div>
                    <div class="horizontal-input">
                        <v-file-input
                            v-model="form.files"
                            required
                            outlined
                            dense
                            multiple
                            prepend-icon=""
                            prepend-inner-icon="mdi-paperclip"
                            accept=".json"
                            :placeholder="t('file_manager_label_browse_files')"
                            :error-messages="form.errors.get('files.0') || form.errors.get('files')"
                            @click:clear="clearFiles"
                        ></v-file-input>
                    </div>
                </div>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                color="primary"
                @click="submit"
                width="45%"
                :loading="form.busy"
                :disabled="form.busy || !form.files || form.files.length === 0"
            >
                {{ t('general_action_execute') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="orange"
                @click="cancel"
                width="45%"
                dark
                :disabled="form.busy"
            >
                {{ t('general_action_cancel') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
